import jwtDecode from "jwt-decode"
import { useState, useRef, useEffect } from "preact/hooks"
import { ModalWrapper, Modal } from "src/utils/fw"

import { useInterval, useJitsi } from "../utils/hooks"
import { get, post, put } from "../utils/http"

import { Row, Column } from "./layout"
import * as styles from "./styles"
import { getJaaSToken } from "./jitsi/api"
import socket from "src/utils/socket"
import { userID, userName, headshot, eventID, company } from "src/utils/datalayer"

const Others = ({ participants, tableName, seatsPerTable }) => {
	const [othersCard, setOthersCard] = useState(false)
	const close = e => {
		e.stopPropagation()
		setOthersCard(false)
	}

	return <div
		className="participant others"
		onclick={e => {
			e.stopPropagation()
			setOthersCard(true)
		}}
	>
		<span className="others_text" >and {participants.length - seatsPerTable}<br />others</span>
		{othersCard
			? <Modal dismiss={close}>
				<ModalWrapper>
					<OthersCard
						participants={participants}
						tableName={tableName}
						dismiss={close}
					/>
				</ModalWrapper>
			</Modal>
			: null}
	</div>
}

const OthersCard = ({ participants, dismiss, tableName }) => <Column
	styleOverride={{ ...styles.fcenter, margin: "5px", padding: "5px", width: "400px" }}
>
	<h3 style={{ margin: "5px", padding: "5px" }}>{tableName}</h3>
	<Row styleOverride={{ flexWrap: "wrap" }}>
		{participants.map(({ name }, i) =>
			<p key={i} className="otherscard_name" style={{ margin: "5px", padding: "5px" }}>{name}</p>,
		)}
	</Row>
	<button className="otherscard_close" style={{
		background: "none",
		border: "2px solid white",
		borderRadius: "6px",
		margin: "5px",
		padding: "5px",
	}} onclick={dismiss}
	>Close</button>
</Column>

const InfoCard = ({ participant, hide, contactUser = false }) => <div
	style={{
		...styles.fcenter,
		...styles.fullscreen,
		...styles.whitewash,
	}}
>
	<div
		style={{
			...styles.fr,
			...styles.fcenter,
			...styles.rounded,
			...styles.bg(styles.colors.agm21Color),
			...styles.pad("2vw"),
			...styles.rel,
		}}
	>
		<p
			style={{
				...styles.abs,
				right: "10px",
				top: "4px",
			}}
			onclick={hide}
		>X</p>
		{participant.headshot && <img src={participant.headshot} style={{ height: "18vw" }} />}
		<div style={{ ...styles.fc, ...styles.fcenter, alignItems: "stretch", }}>
			<p>Company: {participant.company}</p>
			<p>Name: {participant.name}</p>
			<button style={{backgroundColor: "#e31d48", border: 0, borderRadius: "0.5vw"}} onClick={() => window.openDM(participant.userRegID)}>Message me</button>
		</div>
	</div>
</div>

const Participant = participant => {
	const [isActive, setIsActive] = useState(false)
	const show = event => {
		event.stopPropagation()
		setIsActive(!isActive)
	}

	const hide = event => {
		event.stopPropagation()
		setIsActive(false)
	}

	return <div className={`participant participant${participant.id + 1}`} onclick={show}>
		{isActive ? <InfoCard participant={participant} hide={hide} /> : null}
		{participant.headshot ? <img style={{ maxHeight: "100%", maxWidth: "100%" }} src={participant.headshot} title="click me for participant info" /> : participant.initials}
	</div>
}

const Table = ({ id, participants = [], joinCall, seatsPerTable, contactUser = false, offset = 0 }) => {
	const overflowed = participants.length > seatsPerTable
	return <div id={`table${id + 1}`} style={{ cursor: "pointer" }} class="hotspot _gtm-event" data-event-category="Networking" data-event-action="Link Click" data-event-label={`table${id + 1}`} onclick={() => {
		joinCall(id)
	}}
	>
		{participants
			.slice(0, seatsPerTable)
			.map(({ id, ...rest }, i) => <Participant
				id={i}
				contactUser = {contactUser}
				{...rest}
				userRegID={id}
			/>)
		}
		{overflowed ? <Others participants={participants} tableName={`Table ${id + offset + 1}`} seatsPerTable={seatsPerTable} /> : null}
	</div>
}

export const RoundTables = ({
	numTables = 4,
	seatsPerTable = 8,
	limit=false,
	offset = 0,
	dataSource = "https://db.swoogo-retrofit.tkevents.io",
	roomBasename = "",
	allowComunication = true,
	contactUser = false
}) => {

	const [ws, setWs] = useState(null)
	const { current: jitsiWindowID } = useRef(Math.floor(Math.random() * 1e5))
	const [callNumber, setCallNumber] = useState(null)

	const [jwt, updatejwt] = useState("")

	useEffect(async () => {
		if (ws == null) {
			let wsocket = socket(dataSource, true, userID)
			wsocket.setVar("tableNum", callNumber)
			wsocket.onReconnect(({tableNum}) => {
				console.log("Reconnect handler runnning, sending event ", tableNum)
				joinCall(tableNum)
			})
			setWs(wsocket)
		}
	})

	useEffect(async () => {
		const interval = window.setInterval(
			async () => { updatejwt(await getJaaSToken()) },
			7200000,
		)

		updatejwt(await getJaaSToken())

		return () => window.clearInterval(interval)
	}, [])
	const options = {
		jwt,
		parentNode: document.getElementById(`${jitsiWindowID}`),
		roomName:
			callNumber === null
				? null
				: `${jwtDecode(jwt).sub}/${roomBasename} ${callNumber + offset + 1}`,
	}

	useJitsi(options, "8x8.vc", {
		allowComunication: allowComunication,
		onDisconnect: () => {
			ws.send(JSON.stringify({
				type: "quit",
				user: { id: userID },
				message: {}
			}))
		}
	})

	const [tables, setTables] = useState(new Array(numTables).fill([]))

	useInterval(async () => {
		try {
			const newParticipants = (await get(`${dataSource}/rt`, { active: true, eventID: `${eventID}-${roomBasename}` }))
				// First sort by recency of the ping, so we get the newest pings first
				.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
				// This part is a bit tricky, we want to filter for just the pings that
				// are the latest ping for that user
				//
				// So for our filtering function, we return "is this the first ping"
				.filter(
					(ping, index, arr) =>
						index === arr.findIndex(
							p => p.name === ping.name
						)
				)
			const newTables = (new Array(numTables).fill(null))
				.map(_ => [])
			newParticipants.forEach(({ tableID, ...rest }) => {
				newTables[tableID].push(rest)
			})
			setTables(newTables)
		} catch (e) {
			if (e.status != 404) { throw e }
		}
	}, 1000)

	const joinCall = number => {
		const initials = userName.split(" ").reduce((acc, val) => `${acc}${val[0]}`, "")

		if (!ws.isActive()) throw "Socket offline"

		ws.send(JSON.stringify({
			type: "jump-in",
			user: { id: userID, company, eventID: `${eventID}-${roomBasename}`, headshot, initials, name: userName, tableID: number },
			message: {}
		}))
		ws.setVar("tableNum", number)
		setCallNumber(number)
	}

	window.joincall = arg => { joinCall(arg) }

	return <>
		<div
			id={jitsiWindowID}
			className="jitsi-screen"
		/>
		{Array(numTables)
			.fill([])
			.map((_, i) => <Table
				joinCall={joinCall}
				id={i}
				offset = {offset}
				participants={tables[i]}
				seatsPerTable={seatsPerTable.length ? seatsPerTable[i] : seatsPerTable}
				onclick={console.log}
				contactUser = {contactUser}
			/>)
		}
	</>
}
